export const slashToSnakeUrl = (path) => {
    return path.replace(/^\//, '').replace(/\//g, '_')
}
